<template>
  <div class="post-page">
    <div class="post-header">
      <h1>
        {{ title }}
      </h1>

      <p class="post-dates">
        {{ $t("created_at") }}: {{ createdAt }}<br />
        {{ $t("updated_at") }}: {{ updatedAt }}
      </p>

      <p class="description">
        {{ description }}
      </p>
    </div>

    <div class="website-global-post-content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "website",
});

defineProps({
  title: {
    type: String,
    default: "ChronoFox",
  },
  description: {
    type: String,
    default: "Blogpost",
  },
  createdAt: {
    type: String,
    default: "xx.xx.yyyy",
  },
  updatedAt: {
    type: String,
    default: "xx.xx.yyyy",
  },
});
</script>

<style>
.website-global-post-content {
  font-size: 1.125rem;
  color: #333;
  line-height: 1.6;
}

.website-global-post-content h2 {
  font-size: 2rem;
  margin: 1rem 0 0.25rem 0;
}

.website-global-post-content h3 {
  font-size: 1.5rem;
  margin: 1rem 0 0.25rem 0;
}

.website-global-post-content p {
  margin: 1rem 0;
}

.website-global-post-content ol,
.website-global-post-content ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.website-global-post-content ol li,
.website-global-post-content ul li {
  margin: 0.5rem 0;
}
</style>

<style scoped>
.post-page {
  padding: 4rem 5%;
  max-width: 1400px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  font-family: "Inter", sans-serif;
}

.post-header h1 {
  font-size: 2.75rem;
  background: linear-gradient(
    to right,
    var(--orange-2),
    var(--yellow-orange-2)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.post-header .post-dates {
  font-size: 1rem;
  color: #555;
  max-width: 700px;
  margin: 0.8rem 0;
  font-style: italic;
}

.post-header .description {
  font-size: 1.125rem;
  color: #555;
}
</style>
